(function (global) {
  'use strict';
  if (global.CarOptionsVWRadioWizard) return;
  var instances = new WeakMap();
  var nextId = 0;
  var activeClose = null;
  var kinds = ['replacement_review', 'existing_rns510', 'existing_touareg', 'system_review'];

  function mount(options) {
    options = options || {};
    var root = options.root;
    if (!root || root.nodeType !== 1) throw new TypeError('A container element is required.');
    if (instances.has(root)) instances.get(root).destroy();
    if (root.childNodes.length) throw new TypeError('The wizard container must be empty.');
    var doc = root.ownerDocument;
    var win = doc.defaultView;
    var config = options.config || {};
    var getVariantId = typeof options.getVariantId === 'function' ? options.getVariantId : function () { return ''; };
    var navigate = typeof options.navigate === 'function' ? options.navigate : function (url) { win.location.assign(url); };
    var uid = 'co-vwrw-' + (++nextId);
    var radios = new Map();
    var models = [];
    var seenModels = new Set();
    (Array.isArray(config.radios) ? config.radios : []).forEach(function (radio) {
      if (!radio || !radio.id || radios.has(String(radio.id))) return;
      radios.set(String(radio.id), {
        id: String(radio.id), title: String(radio.title || 'Volkswagen-radio'), hint: String(radio.hint || ''),
        imageUrl: imageUrl(radio.imageUrl), imageSize: radio.imageSize, imageCrop: radio.imageCrop,
        kind: kinds.indexOf(radio.kind) >= 0 ? radio.kind : 'system_review',
        existingRouteUrl: existingRouteUrl(radio.existingRouteUrl)
      });
    });
    (Array.isArray(config.models) ? config.models : []).forEach(function (model) {
      if (!model || !model.id || seenModels.has(String(model.id))) return;
      seenModels.add(String(model.id));
      models.push({ id: String(model.id), label: String(model.label || 'Volkswagen'),
        familyKey: String(model.familyKey || model.id),
        registrationYears: Array.isArray(model.registrationYears) ? model.registrationYears : [],
        menuRequired: model.menuRequired !== false,
        photoHelpOnly: model.photoHelpOnly === true,
        yearSuggestions: Array.isArray(model.yearSuggestions) ? model.yearSuggestions : [],
        screenVariantId: /^\d+$/.test(String(model.screenVariantId || '')) ? String(model.screenVariantId) : null,
        variantIds: (Array.isArray(model.variantIds) ? model.variantIds : []).map(String),
        radioIds: Array.from(new Set((Array.isArray(model.radioIds) ? model.radioIds : []).map(String))).filter(function (id) { return radios.has(id); })
      });
    });
    var contactBase = contactUrl(config.contactUrl);
    var contactLabel = String(config.contactLabel || 'Vraag advies via WhatsApp');
    var destroyed = false;
    var lastVariant = readVariant();
    var model = modelForVariant(lastVariant);
    var selected = null;
    var showAllModels = false;
    var phase = 'intro';
    var overlay = null;
    var dialog = null;
    var heading = null;
    var opener = null;
    var savedOverflow = null;
    var failedImages = new Set();
    var menuExample = imageUrl(config.menuExampleImageUrl);
    var menuDetail = imageUrl(config.menuDetailImageUrl);
    var tooltip = null;
    var helpPinned = false;
    var helpHovered = false;
    var helpHoverDismissed = false;
    var helpTimer = null;
    var suppressHelpFocus = false;
    var entry = element('div', 'co-vwrw-entry');
    var helpButton = button('', 'menu-help', 'co-vwrw-menu-help');
    helpButton.setAttribute('aria-label', 'Wat is een MENU-knop?');
    helpButton.setAttribute('aria-expanded', 'false');
    helpButton.setAttribute('aria-controls', uid + '-menu-tooltip');
    helpButton.append(menuPhoto(menuExample, 'Voorbeeld van een Volkswagen-radio met MENU-knop', 'co-vwrw-menu-thumbnail'));
    helpButton.append(element('span', 'co-vwrw-menu-help-label', 'Wat is een MENU-knop?'));
    var entryCopy = element('div', 'co-vwrw-entry-copy');
    var entryTitle = element('p', 'co-vwrw-entry-title');
    var entryText = element('p', 'co-vwrw-entry-text');
    entryCopy.append(entryTitle, entryText);
    var entryActions = element('div', 'co-vwrw-entry-actions');
    var openButton = button('Ik heb geen menu knop', 'open', 'co-vwrw-button co-vwrw-button-primary');
    openButton.setAttribute('aria-haspopup', 'dialog');
    entryActions.append(openButton);
    entryCopy.append(entryActions);
    entry.append(helpButton, entryCopy);
    root.append(entry);
    updateNotice();
    entry.addEventListener('click', onEntryClick);
    helpButton.addEventListener('mouseenter', onHelpEnter);
    helpButton.addEventListener('mouseleave', onHelpLeave);
    helpButton.addEventListener('focus', onHelpFocus);
    helpButton.addEventListener('blur', onHelpBlur);

    function element(tag, className, text) {
      var node = doc.createElement(tag);
      if (className) node.className = className;
      if (text != null) node.textContent = text;
      return node;
    }
    function button(text, action, className) {
      var node = element('button', className || 'co-vwrw-button', text);
      node.type = 'button';
      node.dataset.action = action;
      return node;
    }
    function imageUrl(value) {
      if (typeof value !== 'string' || !value.trim()) return null;
      try { var url = new URL(value, doc.baseURI); return /^(https?:)$/.test(url.protocol) ? url.href : null; } catch (_) { return null; }
    }
    function contactUrl(value) {
      try {
        var url = new URL(value);
        return url.protocol === 'https:' && url.hostname === 'wa.me' && !url.username && !url.password && /^\/\d{6,15}\/?$/.test(url.pathname) ? url.origin + url.pathname : null;
      } catch (_) { return null; }
    }
    function existingRouteUrl(value) {
      if (typeof value !== 'string' || !value.trim()) return null;
      try {
        var current = new URL(doc.URL);
        var url = new URL(value, current);
        var variants = url.searchParams.getAll('variant');
        if (!/^(https?:)$/.test(url.protocol) || url.origin !== current.origin || url.username || url.password || url.pathname !== '/products/carplaybox-volkswagen' || variants.length !== 1 || !/^\d+$/.test(variants[0])) return null;
        var route = new URL('/products/carplaybox-volkswagen', current.origin);
        route.searchParams.set('variant', variants[0]);
        return route.href;
      } catch (_) { return null; }
    }
    function screenRouteUrl(radio) {
      if (!model || !model.screenVariantId || !radio || allowedRadio(radio.id) !== radio || (radio.kind !== 'replacement_review' && radio.kind !== 'system_review')) return null;
      try {
        var current = new URL(doc.URL);
        if (!/^(https?:)$/.test(current.protocol)) return null;
        var route = new URL('/products/volkswagen-carplay-scherm', current.origin);
        route.searchParams.set('variant', model.screenVariantId);
        route.searchParams.set('model', model.familyKey);
        route.searchParams.set('generation', model.id);
        route.searchParams.set('radio', radio.id);
        return route.href;
      } catch (_) { return null; }
    }
    function registrationYear(familyKey, variant) {
      try {
        var lp = JSON.parse(win.sessionStorage.getItem('licensePlate'));
        var full = JSON.parse(win.sessionStorage.getItem('licensePlateFullData'));
        if (!lp || !full || String(lp.var) !== variant || !/^(volkswagen|vw)$/i.test(String(full.merk || '').trim())) return null;
        function plate(value) { return String(value || '').replace(/[^a-z0-9]/gi, '').toUpperCase(); }
        if (!plate(lp.license) || plate(lp.license) !== plate(full.kenteken)) return null;
        var expected = familyKey.slice(3).replace(/-/g, ''), name = String(full.handelsbenaming || '').toLowerCase().replace(/[^a-z0-9]/g, '');
        if (name.indexOf(expected) !== 0 || /plus|cabrio|sportsvan|crossgolf/.test(name) || (expected === 'passat' && /cc/.test(name))) return null;
        var date = String(full.datum_eerste_toelating || '').replace(/-/g, '');
        if (!/^\d{8}$/.test(date)) return null;
        var year = Number(date.slice(0, 4)), month = Number(date.slice(4, 6)), day = Number(date.slice(6));
        var check = new Date(Date.UTC(year, month - 1, day));
        if (check.getUTCFullYear() !== year || check.getUTCMonth() !== month - 1 || check.getUTCDate() !== day) return null;
        var dutchDate = String(full.datum_eerste_tenaamstelling_in_nederland || '').replace(/-/g, '');
        if (dutchDate && dutchDate !== date) return null;
        return year;
      } catch (_) { return null; }
    }
    function registrationSuggestion() {
      if (!model || !model.screenVariantId || !model.yearSuggestions.length) return null;
      var year = registrationYear(model.familyKey, lastVariant);
      if (year === null) return null;
      var matches = model.yearSuggestions.filter(function (rule) { return year >= rule.from && year <= rule.to && model.radioIds.indexOf(rule.radioId) !== -1; });
      return matches.length === 1 ? allowedRadio(matches[0].radioId) : null;
    }
    function initialPhase() { return !model ? 'model' : model.photoHelpOnly ? 'photo' : 'radios'; }
    function goToScreen(radio, suggested) {
      var route = screenRouteUrl(radio);
      if (!route) return false;
      if (suggested) { var url = new URL(route); url.searchParams.set('source', 'kenteken'); route = url.href; }
      navigate(route);
      return true;
    }
    function readVariant() {
      try { var id = getVariantId(); return id == null ? '' : String(id); } catch (_) { return ''; }
    }
    function modelForVariant(id) {
      var found = models.filter(function (item) { return item.variantIds.indexOf(id) !== -1; });
      if (found.length === 1) return found[0];
      if (!found.length) return null;
      var year = registrationYear(found[0].familyKey, id);
      if (year === null) return null;
      var matched = found.filter(function (item) { var range=item.registrationYears; return range.length === 2 && year >= range[0] && year <= range[1]; });
      return matched.length === 1 ? matched[0] : null;
    }
    function allowedRadio(id) {
      return model && model.radioIds.indexOf(id) !== -1 ? radios.get(id) : null;
    }
    function selectedRadio() { return selected ? allowedRadio(selected) : null; }
    function updateNotice() {
      // The host supplies this requirement for the actual product variant, independent of photo choices.
      var currentModel = modelForVariant(lastVariant);
      root.style.display = currentModel && currentModel.id === 'vw-rns510' ? 'none' : '';
      var existing = currentModel && currentModel.menuRequired === false;
      entryTitle.textContent = existing ? 'Herken jouw radio' : 'Een MENU-knop is vereist';
      entryText.textContent = existing ? 'Bekijk welke radio je hebt.' : 'Controleer of deze knop op jouw radio zit.';
    }
    function menuPhoto(src, alt, className) {
      var frame = element('span', className);
      var fallback = element('span', 'co-vwrw-menu-photo-fallback', 'Foto niet beschikbaar');
      fallback.hidden = !!src;
      if (src) {
        var img = element('img', 'co-vwrw-menu-image');
        img.src = src; img.alt = alt; img.decoding = 'async';
        img.addEventListener('load', positionHelp, { once: true });
        img.addEventListener('error', function () { img.hidden = true; fallback.hidden = false; positionHelp(); }, { once: true });
        frame.append(img);
      }
      frame.append(fallback);
      return frame;
    }
    function clearHelpTimer() { if (helpTimer != null) win.clearTimeout(helpTimer); helpTimer = null; }
    function resumeHelpHover() {
      helpHoverDismissed = false;
      doc.removeEventListener('mousemove', onDismissedHelpMove, true);
    }
    function onDismissedHelpMove(event) {
      if (!helpButton.contains(event.target)) resumeHelpHover();
    }
    function onHelpEnter() { helpHovered = true; clearHelpTimer(); if (!helpHoverDismissed) showHelp(); }
    function onHelpLeave(event) {
      var target = event && event.relatedTarget;
      if (!target || (!helpButton.contains(target) && !(tooltip && tooltip.contains(target)))) resumeHelpHover();
      helpHovered = false; clearHelpTimer();
      helpTimer = win.setTimeout(function () {
        helpTimer = null;
        if (!helpHovered && !helpPinned && doc.activeElement !== helpButton) hideHelp(false);
      }, 180);
    }
    function onHelpFocus() { if (!suppressHelpFocus) { resumeHelpHover(); showHelp(); } }
    function onHelpBlur() { helpPinned = false; if (!helpHovered) hideHelp(false); }
    function onHelpOutside(event) {
      if (tooltip && !helpButton.contains(event.target) && !tooltip.contains(event.target)) hideHelp(false, true);
    }
    function onHelpKeydown(event) {
      if (!tooltip || event.key !== 'Escape') return;
      event.preventDefault(); event.stopPropagation(); hideHelp(true, true);
    }
    function showHelp() {
      if (destroyed || overlay) return;
      clearHelpTimer();
      if (tooltip) return;
      tooltip = element('div', 'co-vwrw-menu-tooltip');
      tooltip.id = uid + '-menu-tooltip';
      tooltip.setAttribute('role', 'tooltip');
      tooltip.append(element('strong', 'co-vwrw-menu-tooltip-title', 'Zo herken je de MENU-knop'));
      tooltip.append(menuPhoto(menuDetail, 'Close-up van de MENU-knop op een Volkswagen-radio', 'co-vwrw-menu-detail'));
      tooltip.append(element('p', 'co-vwrw-menu-tooltip-text', 'Zoek naar de knop met het woord MENU op jouw radio.'));
      tooltip.addEventListener('mouseenter', onHelpEnter);
      tooltip.addEventListener('mouseleave', onHelpLeave);
      doc.body.append(tooltip);
      helpButton.setAttribute('aria-expanded', 'true');
      helpButton.setAttribute('aria-describedby', tooltip.id);
      doc.addEventListener('click', onHelpOutside, true);
      doc.addEventListener('keydown', onHelpKeydown, true);
      win.addEventListener('resize', positionHelp);
      win.addEventListener('scroll', positionHelp, true);
      if (win.visualViewport) { win.visualViewport.addEventListener('resize', positionHelp); win.visualViewport.addEventListener('scroll', positionHelp); }
      positionHelp();
    }
    function positionHelp() {
      if (!tooltip) return;
      var viewport = win.visualViewport;
      var width = viewport ? viewport.width : win.innerWidth;
      var height = viewport ? viewport.height : win.innerHeight;
      var x = viewport ? viewport.offsetLeft : 0;
      var y = viewport ? viewport.offsetTop : 0;
      var rect = helpButton.getBoundingClientRect();
      var popupWidth = Math.max(0, Math.min(360, width - 24));
      tooltip.style.width = popupWidth + 'px';
      tooltip.style.maxHeight = Math.max(0, height - 24) + 'px';
      var popupHeight = tooltip.getBoundingClientRect().height;
      var left = Math.max(x + 12, Math.min(rect.left, x + width - popupWidth - 12));
      var top = rect.bottom + 8;
      if (top + popupHeight > y + height - 12) top = rect.top - popupHeight - 8;
      top = Math.max(y + 12, Math.min(top, y + height - popupHeight - 12));
      tooltip.style.left = left + 'px'; tooltip.style.top = top + 'px';
    }
    function hideHelp(restoreFocus, dismissHover) {
      clearHelpTimer(); helpPinned = false; helpHovered = false;
      // Removing an overlapping portal can fire mouseenter without any pointer movement.
      if (dismissHover) {
        helpHoverDismissed = true;
        doc.addEventListener('mousemove', onDismissedHelpMove, true);
      }
      if (tooltip) {
        tooltip.removeEventListener('mouseenter', onHelpEnter);
        tooltip.removeEventListener('mouseleave', onHelpLeave);
        tooltip.remove(); tooltip = null;
      }
      helpButton.setAttribute('aria-expanded', 'false');
      helpButton.removeAttribute('aria-describedby');
      doc.removeEventListener('click', onHelpOutside, true);
      doc.removeEventListener('keydown', onHelpKeydown, true);
      win.removeEventListener('resize', positionHelp);
      win.removeEventListener('scroll', positionHelp, true);
      if (win.visualViewport) { win.visualViewport.removeEventListener('resize', positionHelp); win.visualViewport.removeEventListener('scroll', positionHelp); }
      if (restoreFocus && helpButton.isConnected) {
        suppressHelpFocus = true; helpButton.focus({ preventScroll: true }); suppressHelpFocus = false;
      }
    }
    function syncVariant() {
      if (destroyed) return false;
      var current = readVariant();
      if (current === lastVariant) return false;
      lastVariant = current;
      showAllModels = false;
      model = modelForVariant(current);
      selected = null;
      hideHelp(false);
      updateNotice();
      if (overlay) {
        phase = initialPhase();
        render('Je auto is gewijzigd. Controleer opnieuw welke radio je hebt.');
      }
      return true;
    }
    function onEntryClick(event) {
      var control = event.target.closest('[data-action]');
      if (!control || !entry.contains(control)) return;
      if (control.dataset.action === 'menu-help') {
        syncVariant();
        if (helpPinned) hideHelp(false, true);
        else { resumeHelpHover(); showHelp(); helpPinned = !!tooltip; }
      } else if (control.dataset.action === 'open') open(control);
    }
    function open(control, modelId) {
      if (destroyed || overlay) return;
      hideHelp(false);
      if (activeClose) activeClose();
      lastVariant = readVariant();
      showAllModels = false;
      model = models.find(function (item) { return item.id === modelId; }) || modelForVariant(lastVariant);
      updateNotice();
      selected = null;
      var suggestion = modelId ? null : registrationSuggestion();
      if (suggestion && goToScreen(suggestion, true)) return;
      phase = initialPhase();
      opener = control;
      overlay = element('div', 'co-vwrw-overlay');
      dialog = element('section', 'co-vwrw-dialog');
      dialog.setAttribute('role', 'dialog');
      dialog.setAttribute('aria-modal', 'true');
      dialog.setAttribute('aria-labelledby', uid + '-heading');
      overlay.append(dialog);
      overlay.addEventListener('click', onClick);
      overlay.addEventListener('change', onChange);
      doc.body.append(overlay);
      savedOverflow = { value: doc.body.style.getPropertyValue('overflow'), priority: doc.body.style.getPropertyPriority('overflow') };
      doc.body.style.setProperty('overflow', 'hidden', 'important');
      doc.addEventListener('keydown', onKeydown, true);
      doc.addEventListener('focusin', onFocusIn, true);
      activeClose = close;
      render();
    }
    function close() {
      if (!overlay) return;
      doc.removeEventListener('keydown', onKeydown, true);
      doc.removeEventListener('focusin', onFocusIn, true);
      overlay.removeEventListener('click', onClick);
      overlay.removeEventListener('change', onChange);
      overlay.remove();
      overlay = dialog = heading = null;
      if (savedOverflow) {
        if (savedOverflow.value) doc.body.style.setProperty('overflow', savedOverflow.value, savedOverflow.priority);
        else doc.body.style.removeProperty('overflow');
        savedOverflow = null;
      }
      if (activeClose === close) activeClose = null;
      if (opener && opener.isConnected) opener.focus({ preventScroll: true });
      opener = null;
    }
    function focusables() {
      return Array.from(dialog.querySelectorAll('button:not(:disabled),a[href],select:not(:disabled),input:not(:disabled),summary,[tabindex="0"]')).filter(function (node) {
        var closed = node.closest('details:not([open])');
        return !node.hidden && !node.closest('[hidden]') && (!closed || (node.tagName === 'SUMMARY' && node.parentElement === closed));
      });
    }
    function onKeydown(event) {
      if (!overlay || activeClose !== close) return;
      if (event.key === 'Escape') { event.preventDefault(); event.stopPropagation(); close(); return; }
      if (event.key !== 'Tab') return;
      var controls = focusables();
      var first = controls[0];
      var last = controls[controls.length - 1];
      if (!first) { event.preventDefault(); heading.focus(); return; }
      if (event.shiftKey && (doc.activeElement === first || controls.indexOf(doc.activeElement) < 0)) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && (doc.activeElement === last || controls.indexOf(doc.activeElement) < 0)) { event.preventDefault(); first.focus(); }
    }
    function onFocusIn(event) {
      if (overlay && activeClose === close && !dialog.contains(event.target) && heading) heading.focus({ preventScroll: true });
    }
    function onChange(event) {
      if (syncVariant()) return;
      if (event.target.matches('select[data-model-select]')) {
        model = models.find(function (item) { return item.id === event.target.value; }) || null;
        selected = null;
        var confirm = dialog.querySelector('[data-action="confirm-model"]');
        if (confirm) confirm.disabled = !model;
      } else if (event.target.matches('input[data-radio-id]')) {
        var id = event.target.dataset.radioId;
        selected = allowedRadio(id) ? id : null;
        var next = dialog.querySelector('[data-action="next"]');
        if (next) next.disabled = !selected;
      }
    }
    function onClick(event) {
      if (event.target === overlay) { close(); return; }
      var control = event.target.closest('[data-action]');
      if (!control || !dialog.contains(control)) return;
      var action = control.dataset.action;
      if (action === 'close' || action === 'return-product') { close(); return; }
      if (syncVariant()) { event.preventDefault(); return; }
      if (action === 'screen-route') {
        var screenRoute = screenRouteUrl(selectedRadio());
        if (!screenRoute || control.href !== screenRoute) event.preventDefault();
        return;
      }
      if (action === 'contact' || action === 'existing-route') return;
      if (action === 'start') phase = initialPhase();
      else if (action === 'confirm-model') { if (!model) return; phase = initialPhase(); }
      else if (action === 'change-model') { selected = null; phase = 'model'; }
      else if (action === 'all-models') { showAllModels = true; model = null; selected = null; phase = 'model'; }
      else if (action === 'next') { if (!selectedRadio()) return; if (goToScreen(selectedRadio(), false)) return; phase = 'summary'; }
      else if (action === 'unknown') { selected = null; phase = 'photo'; }
      else if (action === 'back') { if (phase === 'radios' || phase === 'model' || (model && model.photoHelpOnly)) { close(); return; } phase = initialPhase(); }
      else return;
      render();
    }
    function picture(radio, large) {
      var frame = element('div', large ? 'co-vwrw-photo co-vwrw-photo-summary' : 'co-vwrw-photo');
      var fallback = element('span', 'co-vwrw-photo-fallback', 'Foto niet beschikbaar');
      fallback.hidden = !!radio.imageUrl && !failedImages.has(radio.id);
      if (!fallback.hidden) { frame.append(fallback); return frame; }
      var img = element('img', 'co-vwrw-image');
      img.src = radio.imageUrl;
      img.alt = 'Originele Volkswagen-radio: ' + radio.title;
      img.decoding = 'async';
      img.loading = 'lazy';
      var photo = img, crop = radio.imageCrop, size = radio.imageSize;
      if (crop && size && crop.length === 4 && size.length === 2 && crop[2] > 0 && crop[3] > 0) {
        photo = element('div', 'co-vwrw-photo-crop');
        photo.style.aspectRatio = crop[2] + ' / ' + crop[3];
        img.style.cssText = 'width:' + size[0] / crop[2] * 100 + '%;height:' + size[1] / crop[3] * 100 + '%;left:' + -crop[0] / crop[2] * 100 + '%;top:' + -crop[1] / crop[3] * 100 + '%;';
        photo.append(img);
      }
      img.addEventListener('error', function () { failedImages.add(radio.id); photo.hidden = true; fallback.hidden = false; }, { once: true });
      frame.append(photo, fallback);
      return frame;
    }
    function contact(radio, purpose) {
      if (!contactBase) return element('p', 'co-vwrw-note', 'Advies aanvragen is op dit moment niet beschikbaar. Probeer het later opnieuw.');
      var lines = ['Hallo CarOptions,'];
      if (purpose === 'replacement') lines.push('Ik wil advies over een origineel Volkswagen-scherm met CarPlay.');
      else lines.push('Ik wil graag advies over CarPlay voor mijn Volkswagen.');
      if (model) lines.push('Auto: ' + model.label);
      if (radio) lines.push('Huidige radio: ' + radio.title);
      if (purpose === 'replacement') lines.push('Kunnen jullie controleren welk scherm bij mijn auto past?');
      else lines.push('Kunnen jullie controleren welke oplossing bij mijn auto en radio past?');
      lines.push(purpose === 'photo' ? 'Ik herken mijn radio niet en stuur zelf een foto mee.' : 'Ik kan zelf een foto van mijn huidige radio meesturen.');
      var url = new URL(contactBase);
      url.searchParams.set('text', lines.join('\n'));
      var link = element('a', purpose === 'existing' ? 'co-vwrw-text-button' : 'co-vwrw-button co-vwrw-button-primary', contactLabel);
      link.href = url.href;
      link.target = '_blank';
      link.rel = 'noopener noreferrer';
      link.dataset.action = 'contact';
      return link;
    }
    function addHeading(body, title, description) {
      heading = element('h2', 'co-vwrw-heading', title);
      heading.id = uid + '-heading';
      heading.tabIndex = -1;
      body.append(heading);
      if (description) body.append(element('p', 'co-vwrw-description', description));
    }
    function modelBar(body) {
      if (!model) return;
      var bar = element('div', 'co-vwrw-model-bar');
      var text = element('div', 'co-vwrw-model-name');
      text.append(element('span', 'co-vwrw-eyebrow', 'Jouw Volkswagen'), element('strong', '', model.label));
      bar.append(text, button('Wijzig auto', 'change-model', 'co-vwrw-text-button'));
      body.append(bar);
    }
    function radioGrid(ids, offset) {
      var grid = element('div', 'co-vwrw-grid');
      ids.forEach(function (id, index) {
        var radio = radios.get(id);
        var card = element('label', 'co-vwrw-card');
        var input = element('input', 'co-vwrw-radio');
        input.type = 'radio'; input.name = uid + '-radio'; input.value = id; input.dataset.radioId = id; input.checked = selected === id;
        var titleId = uid + '-radio-title-' + (offset + index);
        var hintId = uid + '-radio-hint-' + (offset + index);
        input.setAttribute('aria-labelledby', titleId);
        if (radio.hint) input.setAttribute('aria-describedby', hintId);
        var face = element('div', 'co-vwrw-card-face');
        face.append(picture(radio, false));
        var info = element('div', 'co-vwrw-card-info');
        var title = element('span', 'co-vwrw-card-title', radio.title); title.id = titleId;
        var tick = element('span', 'co-vwrw-card-tick', '✓'); tick.setAttribute('aria-hidden', 'true');
        info.append(title, tick);
        if (radio.hint) { var hint = element('span', 'co-vwrw-card-hint', radio.hint); hint.id = hintId; info.append(hint); }
        face.append(info); card.append(input, face); grid.append(card);
      });
      return grid;
    }
    function render(message) {
      if (!dialog) return;
      dialog.replaceChildren();
      var top = element('div', 'co-vwrw-top');
      top.append(element('span', 'co-vwrw-brand', 'Volkswagen · Radiohulp'));
      var closeButton = button('×', 'close', 'co-vwrw-close');
      closeButton.setAttribute('aria-label', 'Sluiten');
      top.append(closeButton);
      dialog.append(top);
      var body = element('div', 'co-vwrw-body');
      var footer = element('div', 'co-vwrw-footer');
      if (phase !== 'intro') footer.append(button('Terug', 'back', 'co-vwrw-text-button co-vwrw-back'));
      if (message) {
        var status = element('p', 'co-vwrw-status', message);
        status.setAttribute('role', 'status');
        body.append(status);
      }
      if (phase === 'intro') {
        body.append(element('div', 'co-vwrw-intro-mark', 'CarPlay voor jouw Volkswagen'));
        addHeading(body, 'Ontdek de mogelijkheden voor jouw radio', 'De CarPlayBox past niet op iedere radio.');
        body.append(element('p', 'co-vwrw-description', 'We kunnen ook een origineel Volkswagen-scherm met CarPlay leveren. Kies jouw huidige radio en bekijk de mogelijkheden voor jouw auto.'));
        var steps = element('ol', 'co-vwrw-intro-steps');
        ['Vergelijk je radio met de foto’s', 'Bekijk het scherm en de installatie-opties'].forEach(function (text) { steps.append(element('li', '', text)); });
        body.append(steps);
        footer.append(button('Kies mijn radio', 'start', 'co-vwrw-button co-vwrw-button-primary'));
      } else if (phase === 'model') {
        addHeading(body, 'Welke uitvoering heb je?', 'Kies je generatie en bouwjaar. De radio verschilt per uitvoering. Bij een overgangsjaar controleer je welke uitvoering je hebt.');
        var label = element('label', 'co-vwrw-select-label', 'Model en generatie');
        label.htmlFor = uid + '-model';
        var select = element('select', 'co-vwrw-select');
        select.id = uid + '-model';
        select.dataset.modelSelect = '';
        var empty = element('option', '', 'Kies jouw uitvoering');
        empty.value = '';
        select.append(empty);
        var candidates = models.filter(function (item) { return showAllModels || item.variantIds.indexOf(lastVariant) !== -1; });
        if (!candidates.length) candidates = models;
        candidates.forEach(function (item) { var option = element('option', '', item.label); option.value = item.id; select.append(option); });
        select.value = model ? model.id : '';
        body.append(label, select, button('Mijn auto staat er niet bij', 'unknown', 'co-vwrw-text-button co-vwrw-help-link'));
        if (!showAllModels) body.append(button('Ander Volkswagen-model', 'all-models', 'co-vwrw-text-button co-vwrw-help-link'));
        var confirm = button('Bekijk de radio’s', 'confirm-model', 'co-vwrw-button co-vwrw-button-primary');
        confirm.disabled = !model;
        footer.append(confirm);
      } else if (phase === 'radios') {
        addHeading(body, 'Welke radio zit er in jouw auto?', model && model.screenVariantId ? 'Zonder geschikte aansluiting past de CarPlayBox niet. We kunnen je radio vervangen door een Volkswagen-scherm met CarPlay. Kies hieronder jouw huidige radio.' : 'Kies jouw huidige radio. Dan bekijken we de passende CarPlay-oplossing voor deze generatie.');
        modelBar(body);
        var group = element('fieldset', 'co-vwrw-radio-group');
        group.append(element('legend', 'co-vwrw-sr-only', 'Kies jouw huidige radio'));
        var currentIds = model ? model.radioIds : [];
        group.append(radioGrid(currentIds, 0));
        body.append(group);
        if (!model || !model.radioIds.length) body.append(element('p', 'co-vwrw-description', 'Voor deze auto hebben we nog geen herkenningsfoto. We helpen je graag met een foto van jouw radio.'));
        body.append(button('Mijn radio staat er niet bij / ik twijfel', 'unknown', 'co-vwrw-unknown'));
        var next = button(model && model.screenVariantId ? 'Bekijk mijn scherm' : 'Bekijk de mogelijkheden', 'next', 'co-vwrw-button co-vwrw-button-primary');
        next.disabled = !selectedRadio(); footer.append(next);
      } else if (phase === 'photo') {
        addHeading(body, 'We kijken met je mee', 'Voor deze uitvoering controleren we eerst jouw radio en welke oplossing daarbij past. Stuur een foto van je dashboard en radio.');
        modelBar(body);
        var photoSteps = element('ol', 'co-vwrw-photo-steps');
        ['Zet de radio aan.', 'Fotografeer het hele scherm met de knoppen eromheen.', 'Open WhatsApp en voeg de foto zelf toe aan je bericht.'].forEach(function (text) { photoSteps.append(element('li', '', text)); });
        body.append(photoSteps, element('p', 'co-vwrw-note', 'Je verstuurt het bericht en de foto zelf in WhatsApp.'));
        footer.append(contact(null, 'photo'));
      } else if (phase === 'summary') {
        var radio = selectedRadio();
        if (!radio) { phase = initialPhase(); render(); return; }
        var existing = radio.kind === 'existing_rns510' || radio.kind === 'existing_touareg';
        var screenRoute = screenRouteUrl(radio);
        if (screenRoute) addHeading(body, 'Bekijk het scherm met CarPlay', (radio.id === 'vw-rcd210' ? 'Deze CarPlayBox is niet geschikt voor jouw radio. ' : '') + 'Bekijk ons Volkswagen-scherm met CarPlay en Android Auto, de foto’s en de installatie-opties. Je auto en radiokeuze nemen we mee.');
        else if (radio.kind === 'replacement_review') addHeading(body, 'We controleren welk Volkswagen-scherm bij jouw auto past', (radio.id === 'vw-rcd210' ? 'Deze CarPlayBox is niet geschikt voor jouw radio. ' : '') + 'Voor jouw radio bekijken we een origineel Volkswagen-scherm met CarPlay. De passende uitvoering en inbouw worden eerst gecontroleerd.');
        else if (radio.kind === 'system_review') addHeading(body, 'We kijken welke oplossing bij jouw radio past', 'Met een foto van jouw radio kunnen we de uitvoering controleren en je gericht adviseren over CarPlay.');
        else {
          var description = radio.kind === 'existing_touareg' ? 'De Touareg heeft eigen radiobediening. Een ontbrekende MENU-knop betekent hier niet dat je een vervangscherm nodig hebt.' : 'De RNS510 heeft een eigen CarPlayBox-uitvoering.';
          description += radio.existingRouteUrl ? ' Bekijk de uitvoering voor deze radio en laat zo nodig je radio controleren.' : ' Vraag ons om advies over jouw radio en de passende uitvoering.';
          addHeading(body, 'Bekijk de mogelijkheden met je originele scherm', description);
        }
        var choice = element('div', 'co-vwrw-summary-choice');
        choice.append(picture(radio, true));
        var info = element('div', 'co-vwrw-summary-info');
        info.append(element('span', 'co-vwrw-eyebrow', model.label), element('strong', '', radio.title), button('Andere radio kiezen', 'back', 'co-vwrw-text-button'));
        choice.append(info); body.append(choice);
        if (screenRoute) {
          var screenLink = element('a', 'co-vwrw-button co-vwrw-button-primary', 'Bekijk jouw scherm');
          screenLink.href = screenRoute;
          screenLink.dataset.action = 'screen-route';
          footer.append(screenLink);
        } else if (existing) {
          if (radio.existingRouteUrl) {
            var routeLink = element('a', 'co-vwrw-button co-vwrw-button-primary', 'Bekijk deze CarPlayBox');
            routeLink.href = radio.existingRouteUrl;
            routeLink.dataset.action = 'existing-route';
            footer.append(routeLink);
          } else footer.append(button('Terug naar product', 'return-product', 'co-vwrw-button'));
          footer.append(contact(radio, 'existing'));
        }
        else {
          body.append(element('p', 'co-vwrw-note', 'Je opent een voorbereid bericht. Voeg zelf een foto toe en verstuur het in WhatsApp.'));
          footer.append(contact(radio, radio.kind === 'replacement_review' ? 'replacement' : 'system'));
        }
      }
      dialog.append(body, footer);
      body.scrollTop = 0;
      if (heading) heading.focus({ preventScroll: true });
    }
    function destroy() {
      if (destroyed) return;
      hideHelp(false);
      resumeHelpHover();
      close();
      destroyed = true;
      entry.removeEventListener('click', onEntryClick);
      helpButton.removeEventListener('mouseenter', onHelpEnter);
      helpButton.removeEventListener('mouseleave', onHelpLeave);
      helpButton.removeEventListener('focus', onHelpFocus);
      helpButton.removeEventListener('blur', onHelpBlur);
      entry.remove();
      instances.delete(root);
    }
    var api = { syncVariant: syncVariant, destroy: destroy, openModel: function (id) {
      if (destroyed || !models.some(function (item) { return item.id === id; })) return false;
      open(doc.activeElement, id);
      return !!overlay;
    } };
    instances.set(root, api);
    return api;
  }
  global.CarOptionsVWRadioWizard = Object.freeze({ mount: mount });
})(window);
